import { OutputData } from '@editorjs/editorjs'

import { IAmbulanceReduced } from './ambulance'
import { IBasePublishable, IBaseSeo, IImage } from './base'
import { IBlogCategoryReduced } from './blog-category'
import { IEmployeeReduced } from './employee'

export enum BLOG_POST_CONTENT_VARIANT_ENUM {
	EDITORJS = 'EDITORJS',
	TIPTAP = 'TIPTAP'
}

export interface IBlogPostReduced extends IBasePublishable {
	title: string
	slug: string
	authors: IEmployeeReduced[]
	description: string
	wordCount: number
	previewPhoto: IImage | null
	previewPhotoMobile: IImage | null
	coverPhoto: IImage | null
	coverPhotoMobile: IImage | null
	categories: IBlogCategoryReduced[]
	webContent?: {
		backgroundColor: string
		textColor: string
	}
}

export interface IBlogPost extends IBlogPostReduced, IBaseSeo {
	id: number
	title: string
	slug: string
	content: OutputData
	contentTiptap: string
	contentVariant: BLOG_POST_CONTENT_VARIANT_ENUM
	source: string
	publishedAt: string
	categories: IBlogCategoryReduced[]
	authors: IEmployeeReduced[]
	wordCount: number
	relatedPosts: IBlogPostReduced[]
	ambulances: IAmbulanceReduced[]
}
